import OverseasServicesRouter from './overseas_services'
import overseasSettlementRouter from './overseas-settlement'
import overseasServiceBookingRouter from './overseas-service-booking'
import overseasServiceContentRouter from './overseas-service-content'
import overseasPartnerRouter from './overseas-partner'
import overseasActivityNewsRouter from './overseas-activity-news'
import overseasNewsRouter from './overseas-news'
import overseasContactConfigRouter from './overseas-contact-config'
import overseasHomeBannerRouter from './overseas-home-banner'
import overseasPrivacyTermsRouter from './overseas-privacy-terms'

const overseasPlatformRouter = {
  route: null,
  name: null,
  title: '出海综合服务平台',
  type: 'folder',
  icon: 'iconfont el-icon-s-promotion',
  filePath: 'view/overseas_platform/',
  order: 4,
  inNav: true,
  permission: [
    '查询首页轮播图',
    '查询入驻申请',
    '查询服务分类',
    '查询服务内容',
    '查询服务预约',
    '查询合作单位分类',
    '查询合作单位',
    '查询活动资讯',
    '查询出海资讯',
    '海外发行列表',
    '查询平台联系信息',
    '查询隐私条款',
  ],
  children: [
    overseasHomeBannerRouter,
    ...overseasSettlementRouter.children,
    overseasServiceContentRouter,
    ...overseasServiceBookingRouter.children,
    overseasPartnerRouter,
    overseasActivityNewsRouter,
    overseasNewsRouter,
    OverseasServicesRouter,
    overseasContactConfigRouter,
    overseasPrivacyTermsRouter,
  ],
}

export default overseasPlatformRouter
